// extracted by mini-css-extract-plugin
export default {"breadCrumb":"breadcrumb_breadCrumb__TzBSF"};